import { IFieldLangMap } from '@patsnap/synapse_common_interface'

export const drugDealOrgAttrLangMap: IFieldLangMap = {
  US: {
    cn: '美国',
    en: 'US',
    jp: '米国',
  },
  CN: {
    cn: '中国',
    en: 'CN',
    jp: '中国',
  },
  EUR: {
    cn: '欧洲',
    en: 'EUR',
    jp: '欧州',
  },
  JP: {
    cn: '日本',
    en: 'JP',
    jp: '日本',
  },
  'Outside US': {
    cn: '美国外',
    en: 'Outside US',
    jp: '米国以外',
  },
  'Outside CN': {
    cn: '中国外',
    en: 'Outside CN',
    jp: '中国以外',
  },
  'Outside EUR': {
    cn: '欧洲外',
    en: 'Outside EUR',
    jp: '欧州以外',
  },
  'Outside JP': {
    cn: '日本外',
    en: 'Outside JP',
    jp: '日本以外',
  },
}
